import { FC } from 'react'
import { RESOURCE_TEXT, RESOURCE_TITLES } from '@chegg-wt/core/constants/paraphraser'
import { Resource } from '@chegg-wt/core/types/core'
import { Config } from '@chegg-wt/core/config'
import {
  ResourceCardsContainer,
  ResourceSectionSubText,
  ResourcesSectionTitle,
} from './styled'
import { ResourceCard } from './ResourceCard'

interface ResourceSectionProps {
  resources: Resource[]
}

export const ResourcesSection: FC<ResourceSectionProps> = ({ resources }) => {
  const cardResources = resources.slice(0, 4)
  const title = RESOURCE_TITLES[Config.siteName] || ''

  return (
    <>
      <ResourcesSectionTitle>{title}</ResourcesSectionTitle>
      <ResourceSectionSubText>{RESOURCE_TEXT}</ResourceSectionSubText>
      <ResourceCardsContainer>
        {cardResources.map((card) => {
          return (
            <ResourceCard
              heading={card.header}
              key={card.header}
              guideLink={card.url}
              seoLinks={card.seoLinks}
            />
          )
        })}
      </ResourceCardsContainer>
    </>
  )
}
